import { render, staticRenderFns } from "./TrancheCard.vue?vue&type=template&id=666c56f3&scoped=true&"
import script from "./TrancheCard.vue?vue&type=script&lang=js&"
export * from "./TrancheCard.vue?vue&type=script&lang=js&"
import style0 from "./TrancheCard.vue?vue&type=style&index=0&id=666c56f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666c56f3",
  null
  
)

export default component.exports